import getBoundingClientRect from "./getBoundingClientRect.es.js";
import getDocumentElement from "./getDocumentElement.es.js";
import getWindowScroll from "./getWindowScroll.es.js";
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
export {
  getWindowScrollBarX as default
};
//# sourceMappingURL=getWindowScrollBarX.es.js.map
